import { DataTable } from './DataTable'
import { Button, message } from 'antd'
import { YhBox } from '@/components/YhBox'
import { baseModel } from '../model'
import { UserDeleteOutlined, UserAddOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { setAddCarVisible, onDelete, selectedRowKeys } = baseModel()

    const action = (
        <>
            <Button shape="round" type="primary" onClick={() => setAddCarVisible(true)}>
                <UserAddOutlined />
                添加管理员
            </Button>
            <Button
                shape="round"
                onClick={() => {
                    if (!selectedRowKeys.length) {
                        return message.warning('请选择管理员进行删除功能！')
                    } else {
                        onDelete(selectedRowKeys)
                    }
                }}
            >
                <UserDeleteOutlined />
                一键删除
            </Button>
        </>
    )

    return (
        <div>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
                <DataTable />
            </YhBox>
        </div>
    )
}
